export const SECURE_AND_PAY_ACCOUNT_API = '/api/payment/integration/secure-and-pay/account'
